<template>
  <div class="d-flex items-center justify-content-start gap flex-wrap">
    <div class="cards d-flex justify-content-start" v-for="card in listP" :key="card.name">
      <div class="card d-flex items-start justify-content-around flex-column">
        <div class="w-100 d-flex justify-content-center mb-2">
          <p class="card-title h3 w-100 d-flex justify-content-center"
          :title="card.name"
          >
            <strong>{{ card.name }}</strong>
          </p>
        </div>
        <p class="card-text"><i class="fa fa-phone" aria-hidden="true"></i>
          {{ card.formattedNumber }}</p>
        <p class="card-text"><i class="fa fa-globe" aria-hidden="true"></i>
          {{ card.type == 'WHATS_META' ? "Whats Meta" : "Whats App" }}
        </p>

        <div class="d-flex justify-content-between align-items-center w-100 toggle-row">
          <div class="d-flex align-items-center">
            <p class="mb-0 card-text">
              <i :class="{
                'fa fa-check-square text-success': card.active,
                'fa fa-window-close text-danger': !card.active
              }" aria-hidden="true"></i>
              {{ card.active ? "Ativo" : "Inativo" }}
            </p>
            <ToogleSwitch
              :id="'ToogleSwitchActive-' + card.id"
              :value="card.active"
              @input="(val) => handleToggleChange(card.id, 'active', val)"
              class="ml-2"
            />
          </div>

          <div class="d-flex align-items-center">
            <p class="mb-0 card-text">
              <i :class="{
                'fa fa-check-square text-success': card.receptive,
                'fa fa-window-close text-danger': !card.receptive
              }" aria-hidden="true"></i>
              {{ card.receptive ? "Receptivo" : "Não Receptivo" }}
            </p>
            <ToogleSwitch
              :id="'ToogleSwitchReceptive-' + card.id"
              :value="card.receptive"
              @input="(val) => handleToggleChange(card.id, 'receptive', val)"
              class="ml-2"
            />
          </div>
        </div>

        <div class="d-flex justify-content-center w-100 mt-3" v-if="card.type == 'WHATS_WPP'">
          <div class="icon-link-margin" @click="openModalQrCode(card.number)">
            <i class="fas fa-qrcode"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="add-button-container d-flex justify-content-center align-items-center">
      <defaultbutton v-if="list.length !== 0" class="defaultbutton" :onClick="() => openModalAdd()" btnVariant="btn-third" icon="fas fa-plus"/>
    </div>

    <b-modal id="qr-code-modal" title="QRCODE" @hide="onHideModal" centered>
      <div class="text-center">
        <h2><i class="fas fa-qrcode"></i> QRCODE</h2>
        <img v-if="qrCode" :src="qrCode" alt="QR Code" width="350px">
        <h3 v-else>Você já está conectado</h3>
      </div>
    </b-modal>
  </div>
</template>

<script>
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

export default {
  name: 'ProviderList',
  data () {
    return {
      listP: [],
      qrCode: null
    }
  },
  props: {
    list: {
      type: Array,
      default: () => [] // Boa prática: default para a prop 'list'
    }
  },
  components: {
    defaultbutton,
    ToogleSwitch
  },
  created () {
    // Verifique se a prop 'list' já tem dados.
    // Se não, chame onLoad para carregar os dados iniciais.
    if (this.list.length === 0) {
      this.onLoad()
    }
  },
  // O método onLoad pode ser movido para 'methods' para consistência
  async onLoad () {
    try {
      const response = await NumRepository.getNumberAll()
      this.listP = response.data.map(card => ({
        ...card,
        receptive: card.receptive || false, // Garante que é booleano
        active: card.active || false // Garante que é booleano
        // Adicione 'connected: card.connected || false' se você usa para o QR Code
      }))
    } catch (error) {
      console.error('Erro ao buscar números:', error)
      // Opcional: exibir mensagem de erro ao usuário
    }
  },
  watch: {
    // Este watcher é para quando a prop 'list' muda (se for passada por um pai)
    list: {
      handler (newVal) {
        this.listP = newVal.map(card => ({
          ...card,
          receptive: card.receptive || false,
          active: card.active || false
          // Adicione 'connected: card.connected || false' se você usa para o QR Code
        }))
      },
      immediate: true // Garante que execute na montagem
    }
    // Remova o watcher em listP que usava $watch.
    // A lógica de salvar será tratada diretamente pelo handleToggleChange.
  },
  methods: {
    handleClick (info) {
      this.$emit('clicked-open', info)
    },
    openModalAdd () {
      this.$emit('clicked-add')
    },
    async openModalQrCode (identifierProvider) {
      try {
        const response = await AtendimentoRepository.GetQrCode({ identifierProvider })
        this.qrCode = response.data.qrCode
        this.$bvModal.show('qr-code-modal')
      } catch (error) {
        console.error('Erro ao carregar QR Code:', error)
      }
    },
    // NOVO MÉTODO: Lida com a mudança do toggle
    async handleToggleChange (cardId, fieldName, newValue) {
      const cardIndex = this.listP.findIndex(c => c.id === cardId)
      if (cardIndex === -1) {
        console.error(`Card com ID ${cardId} não encontrado.`)
        return
      }

      // Salva o valor original para possível reversão
      const originalValue = this.listP[cardIndex][fieldName]
      // Atualiza o valor no frontend imediatamente para melhor UX
      this.$set(this.listP[cardIndex], fieldName, newValue)

      // Prepara a requisição com APENAS a propriedade que mudou
      const requestConfig = {
        id: cardId,
        [fieldName]: newValue ? 1 : 0 // Converte boolean para 1 ou 0
      }

      try {
        await NumRepository.update(requestConfig)
        console.log(`Sucesso ao atualizar ${fieldName} para ${newValue} no card ${cardId}`)
        // Opcional: toast de sucesso
        // if (this.$toast && this.$toast.success) {
        //   this.$toast.success('Dados atualizados com sucesso!');
        // }
      } catch (error) {
        console.error(`Erro ao atualizar ${fieldName} para o card ${cardId}:`, error)
        // Reverte o valor no frontend em caso de erro da API
        this.$set(this.listP[cardIndex], fieldName, originalValue)
        // Opcional: toast de erro
        if (this.$toast && this.$toast.error) {
          this.$toast.error('Erro ao atualizar dados!')
        }
      }
    },
    // Removido o método 'save' antigo, pois o handleToggleChange o substituiu
    onHideModal () {
      this.qrCode = null
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  border: none;
  color: #ffffff;
  background-color: #04A791;
  min-height: 40px;
  font-weight: bold;
  box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.5);
  border-radius: 3px;
}
.bb {
  border-bottom: 2px solid #000000;
}
p.card-text {
  font-size: 15px;
  margin-bottom: 0.5rem;
}

.card {
  padding: 1rem 1.5rem;
  color: #000000;
  background-color: #ffffff;
  box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.5);
  min-width: 320px; // Aumentado para acomodar os dois toggles na mesma linha
  min-height: 270px; // Aumentado para acomodar todos os elementos, incluindo o QR Code
  max-width: 320px; // Adicionado max-width para controle
  max-height: 300px; // Adicionado max-height para controle
  border-radius: 10px;
}
.gap {
  gap: 4rem;
}
.add-button-container {
  min-width: auto;
  min-height: 220px;
  padding-bottom: 2rem;
}

.icon-link-margin {
  font-size: 2.5rem;
  color: #04A791;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.icon-link-margin:hover {
  transform: scale(1);
}

.card-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  max-width: 240px;
  text-align: center;
  margin-bottom: 1rem;

  strong {
    font-size: 1.3rem;
    font-weight: bold;
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.toggle-row {
  margin-top: 1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.mt-3 {
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/provedores/list/ProvedorList.vue